import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BusinessLocationIcon from 'assets/images/ion_business-location.svg';
import styles from './styles';

const EquipmentScheduleOrderButtonBar = ({ classes, tenantLocationId, locations = [], setTenantLocation }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const currentLocation = useMemo(() => locations.find(({ _id }) => _id === tenantLocationId), [tenantLocationId, locations])

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (option) => () => {
    setTenantLocation(option._id)
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box className={classes.buttonBar}>
      <Button
        variant="filled"
        color="secondary"
        className={classes.locationButton}
        disableTouchRipple
        aria-controls={open ? 'filters-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        endIcon={<ExpandMoreIcon />}
      >
        <span>
          <img src={BusinessLocationIcon} alt="location" className={classes.locationButtonImg} />
          {currentLocation?.name}
        </span>
      </Button>
      <Menu
        id="filters-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        getContentAnchorEl={null}
        MenuListProps={{
          className: classes.menuList,
        }}
        PaperProps={{
          style: {
            width: anchorEl ? anchorEl.clientWidth : 200,
          },
        }}
      >
        {locations.map((location) => {
          const isSelected = tenantLocationId === location._id;
          return (
            <MenuItem
              key={location._id}
              value={location._id}
              selected={isSelected}
              className={isSelected ? classes.selectedMenuItem : null}
              onClick={handleSelect(location)}
            >
              {/* {isSelected && <CheckIcon style={{ marginRight: 8 }} fontSize="small" />} */}
              {location.name}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

EquipmentScheduleOrderButtonBar.propTypes = {
  classes: propTypes.object.isRequired,
  tenantLocationId: propTypes.string,
  locations: propTypes.array.isRequired,
  setTenantLocation: propTypes.func.isRequired,
};

export default withStyles(styles)(EquipmentScheduleOrderButtonBar);
